import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=9056effa"
import script from "./MobileMenu.vue?vue&type=script&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports